import { render, staticRenderFns } from "./earthquakeReportComponent.vue?vue&type=template&id=52992c51&scoped=true&"
import script from "./earthquakeReportComponent.vue?vue&type=script&lang=js&"
export * from "./earthquakeReportComponent.vue?vue&type=script&lang=js&"
import style0 from "./earthquakeReportComponent.vue?vue&type=style&index=0&id=52992c51&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52992c51",
  null
  
)

export default component.exports